namespace Portico.Models.Enterprise {
    import pmg = Portico.Models.Gateway;

    export interface IPrescriberLicense {
        prescriberLicenseId: number;
        licenseType: string | number;
        licenseNumber: string;
    }

    export class PrescriberLicense implements IPrescriberLicense {
        prescriberLicenseId: number;
        licenseType: string | number;
        licenseNumber: string;

        constructor(obj?: IPrescriberLicense | any) {
            this.prescriberLicenseId = null;
            this.licenseType = null;
            this.licenseNumber = '';

            if (obj) {
                this.prescriberLicenseId = obj.prescriberLicenseId || null;
                this.licenseType = obj.licenseType || null;
                this.licenseNumber = obj.licenseNumber || '';
            }
        }
    }
}